 import DivLoader from 'components/divloader/DivLoader';
 import React, { useState, useEffect, useRef } from 'react';
 import { useParams } from 'react-router-dom';
 import { getUrls } from "api/clients";
 import toast from 'react-hot-toast';
 
 function PaymentStatusNew() {
 
     const { gateway_id , client_id , payment_request_id } = useParams()
     const [initialLoading,setInitialLoading] = useState(true);
     
     const generateLink = () => {
         setInitialLoading(true);
         getUrls(payment_request_id)
         .then((response) => {
            if(response.return_url) {
                window.location.replace(response?.return_url);
            }
         }).catch((err) => {
           toast.error(
             err?.response?.data?.message ??
               "Something went wrong while redirecting to return url"
           );
           
         });
     }
 
     useEffect(() => {
         generateLink()
     },[])
 
     return (
         <>
             {initialLoading ? (
                 <div className="mt-5 pt-5">
                     <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                     <p className="text-center">Redirecting .... please do not close or refresh the page.</p>
                 </div>
             ) : (
                 <></>
             )}
         </>
     )
 }
 
 export default PaymentStatusNew
 